import { Component, OnDestroy, OnInit, Input } from '@angular/core';

@Component({
  selector: 'fm-footer',
  templateUrl: 'form-footer.component.html',
})
export class FormFooterComponent
  implements  OnInit, OnDestroy {
  constructor() {}

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}